module.exports = __webpack_public_path__ + "media/images/icon/icons8-Submit Progress-e49084a6fe0b1120900c30633a3cbed6.png";